<div class="relative w-full flex flex-col-reverse lg:block" #selectContainer>
    
    <!-- BOTON PRINCIPAL -->
    <button
        type="button"
        role="button"
        [class]="cssClass"
        [class.opacity-80]="disabled"
        [disabled]="disabled"
        (click)="toggleDropdown()"
        (keydown)="onKeydown($event)"
        aria-haspopup="listbox"
     >

      <div class="flex items-center justify-between">
        
        <!-- TEXTO DEL BOTON -->
        <span class="block truncate">
            {{ inputLabel }}
        </span>
        
        <!-- FLECHA -->
           <svg class="w-5 h-5 ml-2 transition" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" [class]="{'rotate-180': (openOptions && !isMobile()) || (!openOptions && isMobile())}">
             <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>

      </div>

    </button>

    <!-- DROPDOWN -->
    @if (openOptions) {
      
      <!-- CONTAINER -->
      <div 
          class="absolute z-10 w-full flex flex-col-reverse mb-9 bg-white rounded-md shadow-lg max-h-60 overflow-hidden border border-gray-300 lg:block lg:mt-1" 
          tabindex="-1" 
          role="listbox"
        >

          <!-- BUSCADOR -->
          <div class="sticky top-0 bg-white px-2 py-2 border-b border-gray-200">
            
            <input
              #searchInput
              type="text"
              class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black/20 focus:border-black-500"
              [placeholder]="translation.getText('search_tool', 'placeholder_advanced')"
              (input)="onSearch()"
              [(ngModel)]="searchText"
              (click)="$event.stopPropagation()"
            />

          </div>

          <!-- RESULTADOS -->
          @if (filteredOptions.length > 0) {

            <ul class="py-1 max-h-48 overflow-y-auto no-scrollbar">	

              @for (option of filteredOptions; track option.value) {
                
                <li
                  class="px-3 py-2 cursor-pointer hover:bg-black/10 text-sm"
                  tabindex="0"
                  role="option"
                  aria-selected="false"
                  [class]="{'bg-black/10': option.value === value?.value || highlightedIndex === filteredOptions.indexOf(option)}"
                  (click)="onSelect(option)"
                  (keypress.enter)="onSelect(option)"
                >
                  {{ option.label }}
                </li>

              }

            </ul>

          } 
          
          @else {

            <div class="px-3 py-2 text-gray-500 text-sm">
              No se encontraron resultados
            </div>

          }

      </div>
      
    }

</div>